/** Espelho frontend dos tipos de ação (valores iguais ao backend). Não persistir no browser. */
export const TIPOS_ACAO_ETAPA = [
  'APROVACAO_SIMPLES',
  'APROVACAO_COM_ASSINATURA',
  'PREENCHIMENTO_FORMULARIO',
  'CONFIGURACAO_EDITAL',
  'CONFIGURACAO_DOTACAO',
  'ANALISE_TECNICA',
  'MAPA_COMPARATIVO',
  'AUDITORIA',
  'MINUTA_CLAUSULAS',
];

export const TIPOS_ACAO_ETAPA_LABEL = {
  APROVACAO_SIMPLES: 'Aprovação simples',
  APROVACAO_COM_ASSINATURA: 'Aprovação + assinatura digital',
  PREENCHIMENTO_FORMULARIO: 'Preenchimento de formulário',
  CONFIGURACAO_EDITAL: 'Configuração de edital',
  CONFIGURACAO_DOTACAO: 'Dotação orçamentária',
  ANALISE_TECNICA: 'Análise técnica',
  MAPA_COMPARATIVO: 'Mapa comparativo de propostas',
  AUDITORIA: 'Auditoria',
  MINUTA_CLAUSULAS: 'Minuta (cláusulas)',
};

export function normalizarTipoAcaoEtapa(raw, { exigeEdital = false, exigeAssinatura = true } = {}) {
  const v = String(raw || '')
    .trim()
    .toUpperCase();
  if (TIPOS_ACAO_ETAPA.includes(v)) return v;
  if (exigeEdital) return 'CONFIGURACAO_EDITAL';
  if (exigeAssinatura === false || exigeAssinatura === 0) return 'APROVACAO_SIMPLES';
  return 'APROVACAO_COM_ASSINATURA';
}
